import axios from 'axios';
import toastr from 'toastr';

const installationsCounter = 'https://api.tizeti.com/api/v1/searchinstallation/1';

export const get_installation_count_by_asset_zone = async (initialState) => {
  const formData = new URLSearchParams(initialState).toString();
  try {
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${sessionStorage.getItem('token')}`,
    };
    const res = await axios.post(installationsCounter, formData, {
      headers: headers,
    });
    if (res.data) {
      // console.log(res.data);
      return res.data;
    }
  } catch (error) {
    console.error(error);
    toastr.error('error fetching data');
  }
};
